import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import WithMap from "components/Hoc/WithMap";
import { PageHeaderV2 } from "components/PageHeader";
import { useMapContext } from "contexts/googleMap";
import WithLoading from "components/Hoc/WithLoading";

import AddressErrorModalPopup from "components/Modals/AddressErrorModalPopup";
import LatLatNotFallInCurrentStore from "components/Modals/LatLatNotFallInCurrentStore";
import { TranslationText } from "components/TextTranslationContainer";
import { CustomButton } from "components/Button";

import { Loader, AppAction } from "store/actions";
import { useDeliveryAddressContext } from "contexts/userAddressess";
import useConfirmGeoLocation from "service-hooks/useConfirmGeoLocation";
import useCheckOpenedStoresByLatLng from "service-hooks/useCheckOpenedStoresByLatLng";
import usePreFillLocalStorageAddress from "../../hooks/usePreFillLocalStorageAddress";
import { useCustomHistory } from "hooks";
import useDelivertPickupFn from "features/hooks/useDelivertPickupFn";
import ZoomErrorModal from "components/Modals/ZoomErrorModal";

function AddAddressItemPage() {
  usePreFillLocalStorageAddress();

  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const router = useCustomHistory();

  const { goToSettings, goToLogin } = useDelivertPickupFn();

  const { DomainType } = useSelector((state) => state.AppReducer);

  const [mapref, setMapRef] = useState(null);
  const { confirmGeoLocation } = useConfirmGeoLocation();
  const { zoom } = useSelector((state) => state.DeliveryAddressReducer);
  const { googlemapState } = useMapContext();

  const { setAddressState, userAddressState } = useDeliveryAddressContext();
  const checkOpenedStoresByLatLng = useCheckOpenedStoresByLatLng();

  const goBack = () => {
    if (history?.location?.state?.page) {
      router(
        history?.location?.state?.page,
        `/${params.domainName}${history?.location?.state?.page}`,
        DomainType,
      );
    } else {
      router("/", `/${params.domainName}/`, DomainType);
    }
  };

  const redirectToNewManualAddressPage = (areas) => {
    const NEW_MAP_ADD_URL = "/address/add-new-manual-address";
    router(
      NEW_MAP_ADD_URL,
      `/${params.domainName}${NEW_MAP_ADD_URL}`,
      DomainType,
      {
        page: history?.location?.state?.page,
        areas,
      },
      "redirectedFrom=map-address",
    );
  };

  const handleGeoLocation = async () => {
    dispatch(
      AppAction.setTriggerStoreApiAfterAddressSaveOnAppStrt({
        status: false,
        page: null,
      }),
    );
    dispatch(Loader.setLoading(true));
    const res = await confirmGeoLocation();
    if (res?.isValid) {
      const isOpenedAnyStore = await checkOpenedStoresByLatLng(
        googlemapState?.userLocation?.coordinates,
      );
      if (isOpenedAnyStore) {
        redirectToNewManualAddressPage(isOpenedAnyStore);
      }
    } else {
      setAddressState("zoomErrorModal", {
        open: true,
        message: res.message,
      });
    }
    dispatch(Loader.setLoading(false));
  };

  return (
    <WithLoading>
      <div className="relative w-screen h-app-height bg-white store-page-popup">
        <PageHeaderV2
          pageTitle={"Set Delivery Location"}
          onGoBack={goBack}
          authClick={goToLogin}
          userClick={goToSettings}
          containerStyleProps={{
            style: {
              position: "relative",
            },
          }}
        />
        <div
          className="p-4 flex flex-col gap-2 justify-between"
          style={{ height: "calc(100% - 75px)" }}
        >
          <div>
            <TranslationText
              text="Where should we deliver"
              as="h1"
              className="text-24x font-bold text-shadow-forge-900"
            />
            <TranslationText text="We need your location to check if this restaurant delivers to you." />
          </div>

          <WithMap
            class="flex-1"
            width="100%"
            height={"calc(100% - 75px)"}
            showInput={true}
            zoomChanging={true}
            zoom={zoom}
            setMapRef={setMapRef}
            mapref={mapref}
            googlemapState={{
              userLocation: {
                lat: googlemapState?.userLocation?.coordinates?.lat,
                lng: googlemapState?.userLocation?.coordinates?.lng,
              },
              zoom: googlemapState?.zoom,
              mapAddress: googlemapState?.mapAddress,
            }}
            zoomerror={userAddressState?.zoomErrorModal?.message?.msg}
            isZoomModalOpen={userAddressState?.zoomErrorModal?.open}
            setZoomErrorModal={() =>
              setAddressState("zoomErrorModal", { open: false, message: "" })
            }
          />
          <CustomButton onClick={handleGeoLocation}>
            <TranslationText text="Confirm Location" />
          </CustomButton>
          {/* <FixedFooter page={false} from="selec location">
            <span className="block w-full">
              <button
                onClick={handleGeoLocation}
                className="block text-center py-3 rounded text-brand-text-primary bg-brand-base-primary cursor-pointer text-16x w-full"
              >
                <span className="">
                  <div className="">
                    <span className="font-bold">{t("Confirm Location")}</span>
                  </div>
                </span>
              </button>
            </span>
          </FixedFooter> */}
        </div>
      </div>
      <AddressErrorModalPopup />
      <ZoomErrorModal />

      <LatLatNotFallInCurrentStore />
    </WithLoading>
  );
}

export default AddAddressItemPage;
